var lib_core = require("lib-core");
var DrawingElement = require("./../../view/drawingElement.js");

var drawRectangleDataTo2D = require("../../view/renderData/drawRectangleDataTo2D.js");
var GridInteractionView = require("../../interactionViews/gridInteractionView.js");

var SelectionGridInteractionView = function (gui, interactionModel, parentGroup, layers) {
    this.gui = gui;
    this.initGroups(parentGroup, [layers.draw, layers.control]);
    this.addGridInteractionView(gui, interactionModel, parentGroup, layers);
};
lib_core.mixin(SelectionGridInteractionView, DrawingElement);
lib_core.mixin(SelectionGridInteractionView, GridInteractionView);

module.exports = SelectionGridInteractionView;
